import React from 'react';
import { Text } from '@front10/base-elements';
import { useTranslation } from '@front10/utils';

export function Disclaimer(props: { label: string }) {
  const translate = useTranslation();
  return (
    <div>
      <Text
        sx={{ marginTop: '12px', variant: 'text.disclaimer' }}
        dangerouslySetInnerHTML={{
          __html: translate(props.label, 'Disclaimer') || '',
        }}
      />
    </div>
  );
}
